// Main application JavaScript file
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@css/fontawesome-fonts.css' // Override font paths for Vite dev
import '@css/app.css'
import { initOptimizedNavbar } from './components/navbar'
import { initLazyLoading } from './components/lazyLoading'
import { initSearchModal } from './components/searchModal'
import { initUspSliders } from './components/uspSlider'
import { initContactMap } from './components/contactMap'
import { initOembedMediaPlayer } from './components/oembedMediaPlayer'
import { initGtmTracking } from './components/gtmTracking'
import { initStatisticsCounter } from './components/statisticsCounter'
import { initFaqAccordion } from './components/faqAccordion'
import { initFormSlideouts } from './components/formSlideouts'
import { initHistoryTimeline } from './components/historyTimeline'

// Initialize components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Initialize optimized navbar
    const navbar = initOptimizedNavbar(50);

    // Initialize lazy loading for images
    const lazyLoading = initLazyLoading();

    // Initialize search modal
    const searchModal = initSearchModal();

    // Initialize USP sliders
    const uspSliders = initUspSliders();

    // Initialize contact map (lazy loads when in viewport)
    initContactMap();

    // Convert oembed tags to playable iframes (YouTube, Vimeo)
    initOembedMediaPlayer();

    // Initialize GTM dataLayer tracking
    initGtmTracking();

    initStatisticsCounter();
    initFaqAccordion();
    initFormSlideouts();
    initHistoryTimeline();

    document.documentElement.setAttribute('data-app-ready', '');
});
